module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "matrix"
  }, _vm._l((_vm.propMatrix), function(row, idx) {
    return _c('p', {
      key: idx
    }, _vm._l((row), function(cell, jdx) {
      return _c('b', {
        key: jdx,
        class: cell === 1 ? 'c' : cell === 2 ? 'd' : ''
      })
    }), 0)
  }), 0)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7680c023","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/matrix/index.vue
// module id = 157
// module chunks = 1